module.exports = __webpack_public_path__ + "img/r0.c747334d.png";